import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSurveyNoTextError, setSurveyUserSelection } from '../../redux/data/dataSlice';
import config from "../../config/memberhubContents.json";

function SurveyQuestions(props) {
    const dispatch = useDispatch();
    const [freeFormText, setFreeFormText] = useState(null);
    const userSelections = useSelector(state => state.data.surveyUserSelections);
    const surveyCompleted = useSelector(state => state.data.surveySubmissionSuccess);
    const surveyNoTextError = useSelector(state => state.data.surveyNoTextError);
    const questions = props && props.questions;
    const currentQuestionIndex = props && props.current;
    const reviewing = props && props.current && props.current === questions.length;
    const rectangularImgs = props && props.rectangularImgs;
    const isMobileView = props && props.isMobileView;

    const handleRadioSelection = (questionIndex, questionId, answerId) => {
        let selections = [...userSelections];

        selections[questionIndex] = {
            question_id: questionId,
            selected_answers: [answerId],
            text_answer: null,
            other: null
        };
        props.setSurveyError(false);
        dispatch(setSurveyUserSelection(selections));
    };

    const handleTextInput = (questionIndex, questionId, textValue) => {
        let selections = [...userSelections];

        selections[questionIndex] = {
            question_id: questionId,
            selected_answers: null,
            text_answer: textValue,
            other: null
        };
        props.setSurveyError(null);
        dispatch(setSurveyNoTextError(null));
        dispatch(setSurveyUserSelection(selections));
    };

    const handleCheckboxSelection = (questionIndex, questionId, answerId) => {
        let selections = [...userSelections];

        if (!selections[questionIndex]) {
            selections[questionIndex] = {
                question_id: questionId,
                selected_answers: [answerId],
                text_answer: null,
                other: null
            };
        } else {
            if (!selections[questionIndex].selected_answers) {
                selections[questionIndex] = {...selections[questionIndex]};
                selections[questionIndex].selected_answers = [answerId];
            } else {
                let answers = [...selections[questionIndex].selected_answers];
                let index = answers.indexOf(answerId);
                if (index === -1) {
                    answers.push(answerId);
                } else {
                    answers.splice(index, 1);
                }
                selections[questionIndex] = {...selections[questionIndex]};
                selections[questionIndex].selected_answers = answers;
            }
        }

        props.setSurveyError(false);
        dispatch(setSurveyUserSelection(selections));
    };

    const handleOtherSelection = (questionIndex, questionId, other, inputText) => {
        let selections = [...userSelections];

        if (other.checked) {
            const otherTextbox = document.getElementById(`question_${questionIndex}option_other_text`);
            const text = inputText ?? freeFormText ?? otherTextbox.value;
            if (selections[questionIndex]) {
                selections[questionIndex] = {...selections[questionIndex]};
                if (!selections[questionIndex].selected_answers) {
                    selections[questionIndex].selected_answers = [];
                }
                selections[questionIndex].other = text ?? freeFormText;
            } else {
                selections[questionIndex] = {
                    question_id: questionId,
                    selected_answers: [],
                    text_answer: null,
                    other: text
                };
            }
            if (text) {
                dispatch(setSurveyNoTextError(null));
            } else {
                dispatch(setSurveyNoTextError(true));
            }
        } else {
            dispatch(setSurveyNoTextError(null));
            if (selections[questionIndex]) {
                selections[questionIndex] = {...selections[questionIndex]};
                selections[questionIndex].other = null;
            }
        }
        props.setSurveyError(false);
        dispatch(setSurveyUserSelection(selections));
    };

    const handleOtherTextInput = (questionIndex, questionId, text) => {
        setFreeFormText(text);
        let checkbox = document.getElementById(`question_${questionIndex}option_other`);
        handleOtherSelection(questionIndex, questionId, checkbox, text);
    };

    return questions.map((question, questionIndex) =>
        <div className={`modal-survey-question${questionIndex === currentQuestionIndex || reviewing || surveyCompleted ? ' active' : ''}`} key={questionIndex}>
            <div className="modal-survey-question-text">{question.value}</div>
            {(() => {
                const threeColumns = question.answer_options && question.answer_options.length > 4;
                const hasImages = question.answer_options && question.answer_options[0] && question.answer_options[0].image_url;
                const classes = `modal-options${!hasImages ? ' no-images' : rectangularImgs ?
                    ' rectangular-img-options' : threeColumns && !isMobileView ? ' three-col' : ' two-col'}${reviewing ?
                    ' reviewing' : ''}${surveyCompleted ? ' survey-completed' : ''}`;

                switch(question.question_type) {
                    case 'select_one':
                        return (
                            <div className={classes}>
                            { question.answer_options.map((answer, answerIndex) => {
                                return (
                                    <div className="modal-answer-option" key={answerIndex}>
                                        <div className={`modal-answer-option-input ${hasImages ? 'has-images' : 'no-images'} ${surveyCompleted ? 'survey-completed' : ''}`}>
                                            <input type="radio" name={`question_${questionIndex}_option`} id={`question_${questionIndex}_option_${answerIndex}`} value={answer.id}
                                                className="modal-radio" onChange={() => handleRadioSelection(questionIndex, question.id, answer.id)}/>
                                            <label className="modal-answer-option-lbl" htmlFor={`question_${questionIndex}_option_${answerIndex}`}>
                                                {answer.value}
                                            </label>
                                        </div>
                                        { hasImages &&
                                            <label htmlFor={`question_${questionIndex}_option_${answerIndex}`}>
                                            { props.rectangularImgs ?
                                                <img src={answer.image_url} alt={answer.value} />
                                                :
                                                <div className="modal-answer-option-img" style={{ backgroundImage: `url("${answer.image_url}")` }}
                                                alt={answer.value}></div>
                                            }
                                            </label>
                                        }
                                    </div>);
                            })}
                            </div>
                        );

                    case 'select_multiple':
                        return (
                            <div className={classes}>
                            { question.answer_options.map((answer, answerIndex) => {
                            return (
                                <div className="modal-answer-option" key={answerIndex}>
                                    <div className={`modal-answer-option-input ${hasImages ? 'has-images' : 'no-images'} ${surveyCompleted ? 'survey-completed' : ''}`}>
                                        <input type="checkbox" name={`question_${questionIndex}_option`} id={`question_${questionIndex}option_${answerIndex}`} value={answer.id}
                                            className="modal-checkbox" onChange={() => handleCheckboxSelection(questionIndex, question.id, answer.id)}/>
                                        <label className="modal-answer-option-lbl" htmlFor={`question_${questionIndex}option_${answerIndex}`}>
                                            {answer.value}
                                        </label>
                                    </div>
                                    { hasImages &&
                                        <label htmlFor={`question_${questionIndex}option_${answerIndex}`}>
                                        { props.rectangularImgs ?
                                            <img src={answer.image_url} alt={answer.value} />
                                            :
                                            <div className="modal-answer-option-img" style={{ backgroundImage: `url("${answer.image_url}")` }}
                                            alt={answer.value}></div>
                                        }
                                        </label>
                                    }
                                </div>
                            )})}
                            { question.allow_other &&
                            <div className="modal-answer-option">
                                <div className={`modal-answer-option-input other no-images ${surveyCompleted ? 'survey-completed' : ''}`}>
                                    <input type="checkbox" name={`question_${questionIndex}_option`} id={`question_${questionIndex}option_other`}
                                        className="modal-checkbox" onChange={e => handleOtherSelection(questionIndex, question.id, e.target)}/>
                                    <label className="modal-answer-option-lbl" htmlFor={`question_${questionIndex}option_other`}>
                                        Other
                                    </label>
                                    <div className="flex-break"></div>
                                    <input type="text" className={`modal-answer-option-input-freeform ${surveyNoTextError ? 'survey-error' : ''}`} id={`question_${questionIndex}option_other_text`}
                                        onChange={e => handleOtherTextInput(questionIndex, question.id, e.target.value)} placeholder={config.surveyTextAreaPlaceHolder}/>
                                </div>
                                { surveyNoTextError && <div className="modal-textarea-error-msg freeform">
                                    { config.surveyTextAreaError }
                                </div> }
                            </div>
                            }
                            </div>
                        );

                    case 'text':
                    default:
                        return (
                            <div className="modal-options modal-text-option">
                                <div className={`modal-answer-option-input textarea-input ${surveyCompleted ? 'survey-completed' : ''}`}>
                                    <textarea style={{resize: 'none'}} placeholder={config.surveyTextAreaPlaceHolder} name={`question_${questionIndex}_option`}
                                        id={`question_${questionIndex}_textarea`} className={`modal-text-area ${surveyNoTextError ? 'survey-error' : ''}`}
                                        onChange={e => handleTextInput(questionIndex, question.id, e.target.value)} autoFocus={true} />
                                    { surveyNoTextError && <div className="modal-textarea-error-msg">{ config.surveyTextAreaError }</div> }
                                </div>
                            </div>
                        );
            }})()}
        </div>
    );
}

export default SurveyQuestions;
